import React, { useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { Button, Form, Table } from 'react-bootstrap'
// import { removeLeadingZeros } from '../../helper/function'
import { errorToast, successToast } from '../../util/Toast/toast'
import DeletePopup from '../../component/deletePopup'

const DynamicTableForm = () => {
  const { control, trigger, watch } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'pricingTableDetails'
  })
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const openDeleteModal = (_id) => {
    setDeleteId(_id)
    setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  const onDelete = () => {
    if (watch('pricingTableDetails')?.length === 1) {
      errorToast('At least one row is required in the pricing table')
      return
    }
    remove(deleteId)
    successToast("Row deleted successfully")
    setIsDeleteModalOpen(false)
  }

  return (
    <div>
      <div className="pricing_table_main_div">
        <Table bordered responsive>
          <thead>
            <tr>
              <th>
                Bedrooms<span className="text-danger"> *</span>
              </th>
              <th>
                Bathrooms<span className="text-danger"> *</span>
              </th>
              <th>
                Square Feet<span className="text-danger"> *</span>
              </th>
              <th>
                Price<span className="text-danger"> *</span>
              </th>
              <th>
                Exceed Price<span className="text-danger"> *</span>
              </th>
              <th>
                Cleaner Payout<span className="text-danger"> *</span>
              </th>
              <th>
                Avg Time<span className="text-danger"> *</span>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {fields?.map((item, index) => (
              <tr key={item.id}>
                <td>
                  <Controller
                    name={`pricingTableDetails.${index}.bedroom`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <Form.Control
                          type="number"
                          placeholder="Bedrooms"
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value)
                            trigger(`pricingTableDetails.${index}.bedroom`)
                          }}
                        />
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td>
                  <Controller
                    name={`pricingTableDetails.${index}.bathroom`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <Form.Control
                          type="number"
                          placeholder="Bathrooms"
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value)
                            trigger(`pricingTableDetails.${index}.bathroom`)
                          }}
                        />
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td>
                  <Controller
                    name={`pricingTableDetails.${index}.square_feet`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <Form.Control
                          type="number"
                          placeholder="Square Feet"
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value)
                            trigger(`pricingTableDetails.${index}.square_feet`)
                          }}
                        />
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td className="input_with_icon position-relative">
                  <Controller
                    name={`pricingTableDetails.${index}.price`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <div>
                          <div className="form-control-icon-wrap ">
                            <Form.Control
                              type="number"
                              placeholder="Price"
                              value={value}
                              className="form-control-with-icon"
                              onChange={(e) => {
                                onChange(e.target.value)
                                trigger(`pricingTableDetails.${index}.price`)
                              }}
                            />
                            <span className="info_box_div" style={{ top: '52%', right: '12px' }}>
                              <span>$</span>
                            </span>
                          </div>
                        </div>
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td className="input_with_icon position-relative">
                  <Controller
                    name={`pricingTableDetails.${index}.exceed_price`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <div>
                          <div className="form-control-icon-wrap ">
                            <Form.Control
                              type="number"
                              placeholder="Exceed Price"
                              value={value}
                              className="form-control-with-icon"
                              onChange={(e) => {
                                onChange(e.target.value)
                                trigger(`pricingTableDetails.${index}.exceed_price`)
                              }}
                            />
                            <span className="info_box_div" style={{ top: '52%', right: '12px' }}>
                              <span>$</span>
                            </span>
                          </div>
                        </div>
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td>
                  <Controller
                    name={`pricingTableDetails.${index}.cleaner_payout`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <Form.Control
                          type="number"
                          placeholder="%"
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value)
                            trigger(`pricingTableDetails.${index}.cleaner_payout`)
                          }}
                        />
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td>
                  <Controller
                    name={`pricingTableDetails.${index}.avg_time`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <Form.Control
                          type="number"
                          placeholder="h"
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value)
                            trigger(`pricingTableDetails.${index}.avg_time`)
                          }}
                        />
                        <small className="text-danger">{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </td>
                <td className="action_field">
                  <div className="icon_box_div delete_icon" onClick={() => openDeleteModal(index)}>
                    <i className="fas fa-trash text-white" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-between mt-3 gap-2 flex-wrap">
        <Button
          className="btn-small"
          variant="primary"
          type="button"
          onClick={() =>
            append({
              pricing_table_detail_id: '',
              bathroom: '',
              bedroom: '',
              square_feet: '',
              price: '',
              exceed_price: '',
              cleaner_payout: '',
              avg_time: ''
            })
          }
        >
          + Add New Line
        </Button>
      </div>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={() => openDeleteModal(null)}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onDelete()}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
      <br />
    </div>
  )
}

export default DynamicTableForm
